import { render } from "./EnquiryView.vue?vue&type=template&id=4c6ef991"
import script from "./EnquiryView.vue?vue&type=script&lang=js"
export * from "./EnquiryView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__